import { awards, contestants, stats } from "@/mocks/chigua";
import { catOf } from "./meta";

const topList = [...contestants].sort((a, b) => b.heat - a.heat).slice(0, 10);

const medalClass = (i: number) =>
  i === 0
    ? "bg-primary-500 text-background-50"
    : i === 1
      ? "bg-secondary-500 text-background-50"
      : i === 2
        ? "bg-accent-500 text-background-50"
        : "bg-background-200 text-foreground-700";

export default function HotList() {
  return (
    <section id="hot" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
          <div>
            <p className="num-tab mb-3 text-xs tracking-[0.3em] text-primary-600">HOT MELONS · 热门瓜料</p>
            <h2 className="font-heading text-3xl font-bold tracking-wide text-foreground-950 md:text-4xl">
              本季热门瓜料 TOP10<span className="text-primary-600">热力榜</span>
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-7 text-foreground-600">
              按当前公开讨论热度排名的候选事件十强。前三名将直接锁定瓜王之夜的种子席位，榜单仍在实时变动。
            </p>
          </div>
          <a
            href="#join"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-heart-3-fill" />
            为你支持的瓜投票
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-[1.15fr_0.85fr]">
          {/* TOP list */}
          <div className="overflow-hidden rounded-3xl bg-background-100 ring-1 ring-background-200">
            <ol>
              {topList.map((item, i) => {
                const c = catOf(item.category);
                const last = i === topList.length - 1;
                return (
                  <li
                    key={item.id}
                    className={`flex items-center gap-4 px-4 py-3.5 transition-colors hover:bg-background-50 md:px-6 ${
                      last ? "" : "border-b border-background-200"
                    }`}
                  >
                    <span className={`num-tab flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-base ${medalClass(i)}`}>
                      {i + 1}
                    </span>
                    <div className="min-w-0 flex-1">
                      <div className="flex flex-wrap items-center gap-2">
                        <h3 className="truncate font-medium text-foreground-950">{item.name}</h3>
                        <span className="hidden shrink-0 rounded-full bg-background-200 px-2 py-0.5 text-[11px] text-foreground-700 sm:inline">
                          {c.name}
                        </span>
                      </div>
                      <div className="mt-2 h-1.5 w-full max-w-md overflow-hidden rounded-full bg-background-200/80">
                        <div
                          className={`h-full rounded-full ${i === 0 ? "bg-primary-500" : i === 1 ? "bg-secondary-500" : i === 2 ? "bg-accent-500" : "bg-background-400"}`}
                          style={{ width: `${item.heat}%` }}
                        />
                      </div>
                    </div>
                    <div className="shrink-0 text-right">
                      <p className="num-tab text-lg text-primary-600">{item.heat}</p>
                      <p className="text-[10px] text-foreground-500">热力值</p>
                    </div>
                  </li>
                );
              })}
            </ol>
          </div>

          {/* right: awards + stats */}
          <div className="flex flex-col gap-4">
            <div className="grid grid-cols-2 gap-4">
              {awards.map((a) => (
                <div key={a.title} className="rounded-2xl bg-background-100 p-5 ring-1 ring-background-200">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-2xl text-primary-600">
                    <i className={a.icon} />
                  </span>
                  <h4 className="mt-3 font-heading text-base font-bold text-foreground-950">{a.title}</h4>
                  <p className="mt-1 text-xs leading-5 text-foreground-600">{a.desc}</p>
                </div>
              ))}
            </div>
            <div className="rounded-3xl bg-foreground-950 p-6 text-background-50 md:p-7">
              <h4 className="font-heading text-lg font-bold">吃瓜大赛，岂止吃瓜</h4>
              <p className="mt-2 text-sm leading-6 text-foreground-200">
                每一票都算数。瓜王、黑马、人气之选，都在瓜友的每一次围观与打投里诞生。
              </p>
              <div className="mt-5 grid grid-cols-2 gap-4">
                {stats.map((s) => (
                  <div key={s.label}>
                    <p className="num-tab text-2xl text-accent-300 md:text-3xl">
                      {s.value}
                      <span className="text-base">{s.suffix}</span>
                    </p>
                    <p className="mt-1 text-xs text-foreground-200">{s.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}